import { TreeNode } from 'primeng/api';
import { RawScoresCalculator } from './raw-scores-calculator.utils';
import { CategoryScoresCalculator } from './category-scores-calculator.utils';
import { CapacityDistributionCalculator } from './capacity-distribution-calculator.utils';
import { OperationsHoursCalculator } from './operations-hours-calculator.utils';

// Type definitions matching the C# models
export interface ScheduledHours {
  CommitedHours: number;
  UncommitedHours: number;
}

export interface CategoriesScores {
  PMScore: number;
  ReadyToExecuteScore: number;
  LatenessScore: number;
  PriorityScore: number;
  WorkTypeScore: number;
  StatutoryFlagScore: number;
}

export interface WorkOrderMinimalResponse {
  SAP_WorkOrderId: string;
  SAP_Priority : string;
}

export interface WorkOrderWithScore {
  WorkOrder: WorkOrderMinimalResponse;
  CapacityDistribution?: { [week: number]: ScheduledHours };
  CategoryScores: CategoriesScores;
  TotalWorkHours: number;
  Score: number;
}

export interface FunctionalLocationNode {
  Id: string;
  ObjectType: string;
  Name: string;
  Score: number;  
  ReleasedHours?: number;
  NonReleasedHours?: number;
  CategoryScores: CategoriesScores;
  CapacityDistribution?: { [week: number]: ScheduledHours };
  Children: FunctionalLocationNode[];
  ReleasedWorkOrders: WorkOrderWithScore[];
  NotReleasedWorkOrders: WorkOrderWithScore[];
}

export class FunctionalLocationHierarchyScoresPropagation {

  public static calculateNodeScores(node: FunctionalLocationNode): void {
    node.Children.forEach(child => this.calculateNodeScores(child));
    OperationsHoursCalculator.calculateOperationsHours(node);
    RawScoresCalculator.calculateRawScores(node);
    CategoryScoresCalculator.calculateNodeCategoryScores(node);
    CapacityDistributionCalculator.calculateCapacityDistributions(node);
  }
}
